import { UriConstant } from "./apiDomain";

export const UriEntity = {
  // TMFC001
  ProductCatalog: UriConstant.URI_TMF620 + "productCatalog",
  ProductOffering: UriConstant.URI_TMF620 + "productOffering",
  ProductOfferingPrice: UriConstant.URI_TMF620 + "productOfferingPrice",
  ProductOfferingPriceMatrix: UriConstant.URI_TMF620 + "productOfferingPriceMatrix",
  ProductSpecification: UriConstant.URI_TMF620 + "productSpecification",
  Category: UriConstant.URI_TMF620 + "category",

  Promotion: UriConstant.URI_TMF671 + "promotion",

  PolicyAction: UriConstant.URI_TMF723 + "policyAction",
  PolicyCondition: UriConstant.URI_TMF723 + "policyCondition",
  PolicyEvent: UriConstant.URI_TMF723 + "policyEvent",
  PolicyRule: UriConstant.URI_TMF723 + "policyRule",
  PolicyVariable: UriConstant.URI_TMF723 + "policyVariable",
  PolicyVariableSet: UriConstant.URI_TMF723 + "policyVariableSet",

  ActionType: UriConstant.URI_TMF671 + "actionType",
  Criteria: UriConstant.URI_TMF671 + "criteria",
  CriteriaSet: UriConstant.URI_TMF671 + "criteriaSet",


  Association: UriConstant.URI_TMF662 + "association",
  AssociationSpecification: UriConstant.URI_TMF662 + "associationSpecification",
  WorkIssue: UriConstant.URI_TMF801 + "workIssue",
  WorkFlow: UriConstant.URI_TMF801 + "workFlow",
  WorkProject: UriConstant.URI_TMF801 + "workProject",

  ProductGroup: UriConstant.URI_TMF806 + "productGroup",
  ProductProperty: UriConstant.URI_TMF806 + "productProperty",
  PropertySpecification: UriConstant.URI_TMF806 + "propertySpecification",
  Community: UriConstant.URI_TMF807 + "community",

  CommunityGroup: UriConstant.URI_TMF808 + "communityGroup",
  OfferInstance: UriConstant.URI_TMF808 + "offerInstance",
  DecisionTableSpecification: UriConstant.URI_TMF809+"decisionTableSpecification",

  // TMFC002
  CancelProductOrder: UriConstant.URI_TMF622 + "cancelProductOrder",
  ProductOrder: UriConstant.URI_TMF622 + "productOrder",
  Quote: UriConstant.URI_TMF648 + "quote",
  ShoppingCart: UriConstant.URI_TMF663 + "shoppingCart",

  // TMFC003
  ProcessFlow: UriConstant.URI_TMF701 + "processFlow",
  TaskFlow: UriConstant.URI_TMF701 + "taskFlow",

  // TMFC005
  Product: UriConstant.URI_TMF637 + "product",

  // TMFC006
  ServiceCatalog: UriConstant.URI_TMF633 + "serviceCatalog",
  ServiceCategory: UriConstant.URI_TMF633 + "serviceCategory",
  ServiceCandidate: UriConstant.URI_TMF633 + "serviceCandidate",
  ServiceSpecification: UriConstant.URI_TMF633 + "serviceSpecification",
  ServiceLevelObjective: UriConstant.URI_TMF657 + "serviceLevelObjective",
  ServiceLevelSpecification: UriConstant.URI_TMF657 + "serviceLevelSpecification",

  // TMFC007
  CancelServiceOrder: UriConstant.URI_TMF641 + "cancelServiceOrder",
  ServiceOrder: UriConstant.URI_TMF641 + "serviceOrder",

  // TMFC008
  Service: UriConstant.URI_TMF638 + "shared",
  ResourceFacingService: UriConstant.URI_TMF638 + "shared",
  CustomerFacingService: UriConstant.URI_TMF638 + "shared",

  // TMFC009
  CheckServiceQualification: UriConstant.URI_TMF645 + "checkServiceQualification",
  QueryServiceQualification: UriConstant.URI_TMF645 + "queryServiceQualification",

  // TMFC010
  ResourceCatalog: UriConstant.URI_TMF634 + "resourceCatalog",
  ResourceCategory: UriConstant.URI_TMF634 + "resourceCategory",
  ResourceCandidate: UriConstant.URI_TMF634 + "resourceCandidate",
  ResourceSpecification: UriConstant.URI_TMF634 + "resourceSpecification",
  LogicalResourceSpecification: UriConstant.URI_TMF634 + "logicalResourceSpecification",
  PhysicalResourceSpecification: UriConstant.URI_TMF634 + "physicalResourceSpecification",
  ResourceFunctionSpecification: UriConstant.URI_TMF634 + "resourceFunctionSpecification",


  // TMFC027
  CheckProductOfferingQualification: UriConstant.URI_TMF679 + "checkProductOfferingQualification",
  QueryProductOfferingQualification: UriConstant.URI_TMF679 + "queryProductOfferingQualification",
  CheckProductConfiguration: UriConstant.URI_TMF760 + "checkProductConfiguration",
  QueryProductConfiguration: UriConstant.URI_TMF760 + "queryProductConfiguration",

  // TMFC011
  CancelResourceOrder: UriConstant.URI_TMF652 + "cancelResourceOrder",
  ResourceOrder: UriConstant.URI_TMF652 + "resourceOrder",

  // TMFC012
  Resource: UriConstant.URI_TMF639 + "resource",
  CapacitySpecification: UriConstant.URI_TMF685 + "capacitySpecification",
  ResourcePool: UriConstant.URI_TMF685 + "resourcePool",
  ResourcePoolSpecification: UriConstant.URI_TMF685 + "resourcePoolSpecification",

  // TMFC100
  Picklist: UriConstant.URI_TMF802 + "picklist",
  CharacteristicCatalog: UriConstant.URI_TMF803 + "characteristicCatalog",
  CharacteristicCategory: UriConstant.URI_TMF803 + "characteristicCategory",
  CharacteristicSpecification: UriConstant.URI_TMF803 + "characteristicSpecification",

  // TMFC102
  Proposal: UriConstant.URI_TMF804 + "proposal",
  ProposalGroup: UriConstant.URI_TMF805 + "proposalGroup",
  ProposalSpecification: UriConstant.URI_TMF805 + "proposalSpecification",

  // TMFC061
  Work: UriConstant.URI_TMF713 + "work",
  WorkSpecification: UriConstant.URI_TMF713 + "workSpecification",
  CheckWorkQualification: UriConstant.URI_TMF714 + "checkWorkQualification",
  QueryWorkQualification: UriConstant.URI_TMF714 + "queryWorkQualification",
  CancelWorkOrder: UriConstant.URI_TMF697 + "cancelWorkOrder",
  WorkOrder: UriConstant.URI_TMF697 + "workOrder",

  // TMFC046
  Appointment: UriConstant.URI_TMF646 + "appointment",
  SearchTimeSlot: UriConstant.URI_TMF646 + "searchTimeSlot",

  // CancelServiceOrder
  DynamicForm: UriConstant.DynamicForm
};

/**
 * hàm lấy ra đuôi url domain path theo key
 * @param entityName key ở trong danh sách các path ở trên
 */
export function getApiUrlPath(entityName: keyof typeof UriEntity): string {
  return UriEntity[entityName] ?? "";
}

